import type React from 'react';

import { Link, Separator, Text } from '@change/ds-core-ui';

import { EmbeddedMedia } from '#src/app/shared/components/embeddedMedia';
import { Html } from '#src/app/shared/components/html';

import { Actions } from './components/Actions';
import { ShareLinks } from './components/ShareLinks';
import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { description, isSimpleUrlDescription, creationDate, embeddedMedia, link },
		actions: { handleLinkClick },
	} = usePageBody();

	return (
		<div className="flex flex-col gap-6 md:gap-12">
			{isSimpleUrlDescription ? (
				// older version of the update form allowed to simply input a url that would end up being the description
				<div className="wrap-break-word">
					<Text className="typography-secondary">{creationDate} —&nbsp;</Text>
					<Link href={description} data-qa="simple-description-link">
						{description}
					</Link>
				</div>
			) : (
				<div className="flex flex-col gap-2">
					<Text>{creationDate}</Text>
					<Html
						size="default"
						variant="body"
						html={description}
						className="leading-[28px] [&>iframe]:aspect-video [&>iframe]:h-auto [&>iframe]:w-full"
						data-qa="petition-update-description"
						expressive
					/>
				</div>
			)}
			{link && (
				<Link href={link.url} target="_blank" onClick={handleLinkClick} data-qa="news-article-link">
					{link.label}
				</Link>
			)}
			{embeddedMedia?.html && (
				<EmbeddedMedia
					html={embeddedMedia.html}
					aspectRatio={embeddedMedia.aspectRatio || undefined}
					className="mt-4"
					data-qa="embedded-media"
				/>
			)}
			<Actions />
			<div className="flex flex-col gap-6">
				<Separator className="my-0" />
				<ShareLinks />
			</div>
		</div>
	);
};
